import styled from "styled-components";

export const VariacoesBoxV2Container = styled.div`
  padding-bottom: 20rem;

  .tabs {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    align-items: flex-end;
    .tab {
      width: 100%;

      .titulo {
        text-align: center;
        color: ${(props) => props.theme.colors.secondary};
        font-weight: normal;
      }

      .destaque {
        height: 2px;
        background-color: #dbdbdb;
        width: 100%;

        &.ativo {
          height: 2px;
          background-color: ${(props) => props.theme.colors.secondary};
        }
      }
    }

    margin-bottom: 30px;
  }

  .texto {
    text-align: left;
    margin: 2rem 0;
    color: ${(props) => props.theme.colors.tertiary};
  }

  .niveis-container {
    margin-top: 2rem;
  }

  .add-nivel {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    justify-content: flex-start;
    margin-top: 1rem;
      height: 50px;
    margin-bottom: 2rem;

    .adicionar-secundaria {
      display: flex;
      align-items: center;
      gap: 8px;
      background-color: ${(props) => props.theme.colors.elements};
      text-align: center;
      padding: 8px 16px;
      height: 33px;
      border-radius: 30px;
      cursor: pointer;
      color: ${(props) => props.theme.colors.tertiary};

      .plus {
        width: 18px;
        fill: ${(props) => props.theme.colors.primary};
      }

      &.bloqueado {
        opacity: 0.5;
        cursor: default;
      }
    }
  }

  @media (max-width: 1024px) {
    padding-bottom: 0rem;
    min-height: 40vh;
  }
`;
